import { GlobalFooter } from "@/patterns/global-footer/src";
import JiraSoftwareNavV2 from "@/templates/jira-product-tour-overview/src/sections/productionized/software-jira-navbar";

import { AISection } from "./sections-v2/ai";
import { CommunitySection } from "./sections-v2/community";
import { LaunchSection } from "./sections-v2/featured-info/launch";
import { PlanSection } from "./sections-v2/featured-info/plan";
import { ReportSection } from "./sections-v2/featured-info/report";
import { TrackSection } from "./sections-v2/featured-info/track";
import { FinalCTASection } from "./sections-v2/final-cta";
import { HeroSection } from "./sections-v2/hero";
import { IntegrationsSection } from "./sections-v2/integrations";
import { ManageSection } from "./sections-v2/manage";
import { TabsSection } from "./sections-v2/tabs";

export const JiraSoftwareFeaturesPageTemplate = () => {
    return (
        <div>
            <JiraSoftwareNavV2 />
            <HeroSection />
            <TabsSection />
            <PlanSection />
            <TrackSection />
            <LaunchSection />
            <ReportSection />
            <AISection />
            <ManageSection />
            <IntegrationsSection />
            <CommunitySection />
            <FinalCTASection />
            <GlobalFooter />
        </div>
    );
};
